import "./App.css";
import Homepage from "./pages/Homepage";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import "./styles/style.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EntryPage from "./pages/EntryPage";
import { useEffect } from "react";
import RegisterUser from "./pages/RegisterUser";
import LoginPage from "./pages/LoginPage";
import NotFound from "./pages/NotFound";
import useAuth, { Authentication } from "./useAuth";
import { ProfilePage } from "./pages/ProfilePage";
import EditProfilePage from "./pages/EditProfile";
import AddNewScheme from "./pages/AddNewScheme";
import SchemesList from "./pages/SchemesList";
import SchemeDetails from "./pages/SchemeDetails";
import DraftAnalysis from "./pages/DraftAnalysis";
import Report from "./pages/Report";
import ReportSchemes from "./pages/ReportSchemes";

const ProtectedAdminRoute = ({ children }) => {
  const { user } = useAuth();
  if (user?.userType?.toLowerCase() !== "admin") {
    return <Navigate to="/my/home" />;
  }
  return children;
};

function App() {
  const Scroll = (props) => {
    const location = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);
    return props.children;
  };

  const { user } = useAuth();
  return (
    <BrowserRouter>
      <ToastContainer position="top-right" />
      <Authentication>
        <Scroll>
          <Routes>
            <Route path="/" element={<Navigate to="/my" />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="/my" element={<EntryPage />}>
              <Route path="" element={<Navigate to="home" />} />

              <Route path="home" element={<Homepage />} />
              <Route path="registerUser" element={<RegisterUser />} />

              <Route path="addNewScheme" element={<AddNewScheme />} />
              <Route path="schemesList" element={<SchemesList />} />
              <Route path="schemeDetails" element={<SchemeDetails />} />
              <Route path="draftAnalysis" element={<DraftAnalysis />} />
              <Route
                path="report"
                element={
                  <ProtectedAdminRoute>
                    <Report />
                  </ProtectedAdminRoute>
                }
              />
              <Route
                path="reportSchemes"
                element={
                  <ProtectedAdminRoute>
                    <ReportSchemes />
                  </ProtectedAdminRoute>
                }
              />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="profile/edit" element={<EditProfilePage />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Scroll>
      </Authentication>
    </BrowserRouter>
  );
}

export default App;
